import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`

* {
    box-sizing: border-box;
  }
  
  body {
    font-family: "Open Sans", sans-serif;
    margin: 0;
  }
  
  ul {
    list-style: none;
    margin: 0;
    padding: 0 0px;
    width: 100%;
    max-width: 350px;
  }

  a, a:visited {
    text-decoration: none;
    color: black;
    
  }
  
  
  h1 {
    font-family: "Caveat Brush", cursive;
    margin-bottom: 20px;
  }
  h2 {
    margin: 10px;
    font-size: 1.25em;
  } 
  
  h3 {
    margin: 10px;
    font-size: 1em;
  }
  
  .material-symbols-rounded {
    font-variation-settings:
    'FILL' 0,
    'wght' 400,
    'GRAD' 0,
    'opsz' 48
  }
  button {
    font-family: "Caveat Brush", cursive;
  }
  input {
    text-align: center;
  }
  .detail-link {
    text-decoration: none;
    color: black;
    appearance: auto;
    background: rgba(100, 100, 100, 0.1);
    border-radius: 10px;
    padding: 3px;
    text-align: center;
    appearance: button;
    line-break: auto;
    border-style: groove;
    margin-top: 18px;
    width: 100%;
    font-family: "Caveat Brush", cursive;
    height: 45px;
    padding-top: 5px;
    margin: 10px 0;
    font-size: 1.4rem
  }

`;

export default GlobalStyle;
